<template lang="pug">
  article.fades(v-if="item", :class="{'opacity-0': !loaded}")
    .content.flex.sm-pt0.sm-mb4(:class="contentClasses")
      .relative.sm-w100-imp(:data-padding="item.primary.padding")
        figure.cursor-pointer(v-if="item.primary.thumbnail.url", @click="$emit('click')")
          img.block.w-full.fit(:src="thumb(item.primary.thumbnail.url)", :alt="item.primary.thumbnail.alt", @load="loaded = true")
        header.absolute.w-100.bottom-0.left-0(style="transform:translateY(100%);padding-top:.8em")
          h1.inline-block {{item.primary.series.data.title | text}} <span class="italic">{{item.primary.series.data.client | text }}</span>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'Index__Item',
  props: ['item'],
  data () {
    return {
      loaded: false,
      winW: window.innerWidth,
      isPortrait: !window.innerWidth ? true : window.innerWidth < 768 // ig browser...
    }
  },
  computed: {
    contentClasses () {
      const data = this.item.primary
      return {
        'pt5 md-pt4b': data.top_margin === 'true',
        'justify-end': data.align === 'right',
        'justify-start': data.align === 'left',
        'justify-center': data.align === 'center'
      }
    }
  },
  methods: {
    thumb (src) {
      const ratio = this.isPortrait ? 0.68 : 0.42
      const length = this.winW * ratio
      return src ? Vue.thumbSrc(src, length) : false
    }
  }
}
</script>

<style scoped>
@import '../style/variables';

[data-padding="slim"]{
  width:calc(100% - 6rem);
}
[data-padding="medium"]{
  width:calc(100% - 12rem);
}

@media (--bkpt-md) {
  [data-padding="slim"]{
    width:calc(100% - 4rem);
  }
  [data-padding="medium"]{
    width:calc(100% - 9rem);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SeriesIndex__Item.vue